<div *ngFor="let schedule of schedules; let i = index">
  <div *ngIf="selectedSchedule == i" class="box">
    <ng-container *ngTemplateOutlet="actions; context: {$implicit: {where: 'before', index: i}}"></ng-container>
    <app-task-scheduler [schedule]="schedule" [showTimezone]="false" (scheduleChange)="scheduleUpdated(i, $event)"></app-task-scheduler>
    <ng-container *ngTemplateOutlet="actions; context: {$implicit: {where: 'after', index: i}}"></ng-container>
  </div>
  <div *ngIf="selectedSchedule != i" class="box-preview" (click)="setSelectedSchedule(i)">
    <div style="margin: 0 10px 5px 10px">
      Starting {{schedule.start | date:'short': '' : translate.currentLang }}, {{ cronBasicDescription(schedule) }} until {{schedule.end | date:'short': '' : translate.currentLang }}<br />
      (Based on: {{schedule.start | date:'short': '' : translate.currentLang }} - {{schedule.end | date:'short': '' : translate.currentLang }} {{ cronDescription(schedule) }})
    </div>
  </div>
</div>
<div *ngIf="schedules.length == 1" class="alert alert-primary" role="alert" style="width:450px">
  <div style="display:flex;flex-flow:row">
    <div style="margin-right:5px">
      <mat-icon>help</mat-icon>
    </div>
    <div>
      If you want a more extensive schedule. Click the Add button to create multiple schedules to cover your needs.
    </div>
    <div>
      <button mat-flat-button color="primary" (click)="performAction($event, 'after')">Add</button>
    </div>
  </div>
</div>
<ng-template #actions let-d>
  <div class="simple-row" style="padding: 0px 20px">
    <div class="wd-49-per">
    </div>
    <div *ngIf="schedules.length > 1" [style]="d.where == 'before' ? 'display:flex;flex-flow:row;margin-top:-25px' : 'display:flex;flex-flow:row;margin-bottom:-25px'">
      <button mat-mini-fab (click)="performAction($event, d.where)"><mat-icon>add</mat-icon></button>
      <button *ngIf="schedules.length > 1" mat-mini-fab color="accent" matTooltip="Delete Block" (click)="deleteAction()"><mat-icon>delete</mat-icon></button>&nbsp;
    </div>
    <div class="wd-49-per">
    </div>
  </div>
</ng-template>
